// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const TRACKING = Object.freeze({
  referrers: {
    keys: [
      `utm_source`,
      `utm_medium`,
      `utm_campaign`,
      `utm_term`,
      `utm_content`,
    ],
  },
  cookies: [
    {
      id: `consent`,
      name: `allow_cookies`,
      isActive: true,
      title: `Cookies`,
      body: `We use cookies to improve your experience on our site. To find out more, read our [privacy notice](/privacy/).`,
    },
    {
      id: `announcement`,
      version: 0,
      isActive: false,
      name: `hide_announcement`,
      title: `Coronavirus (COVID-19)`,
      body: `**We’re here for you**. We know that many of you will be worried about the current situation, and we want to reassure you that our service will continue to operate as normal. We’ll be here to provide you with support and guidance through these difficult times.`,
    },
    {
      id: `preLaunch`,
      version: 0,
      title: `This page is for internal review by #{client name} only`,
      body: `All rights reserved. No part of this webpage may be reproduced, distributed, or transmitted in any form or by any means without the prior written permission of Sleepstation. **Not for public release.**`,
    },
  ],
})

export default TRACKING
